import React from 'react';

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
  active?: boolean;
}

const HausIcon: React.FC<IconProps> = ({
  className,
  style,
  width = 48,
  height = 48,
}) => {
  return (
    <svg
      viewBox="932 333 36 40"
      width={width}
      height={height}
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M932 347L950 333L968 347V369C968 370.061 967.579 371.078 966.828 371.828C966.078 372.579 965.061 373 964 373H936C934.939 373 933.922 372.579 933.172 371.828C932.421 371.078 932 370.061 932 369V347Z"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M944 373V353H956V373"
      />
    </svg>
  );
};

export default HausIcon;
